import {Component, ChangeDetectionStrategy} from '@angular/core';
import {PermissionKeys} from '../app.constants';

@Component({
    selector: 'app-ewallets',
    templateUrl: './ewallets.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EwalletsComponent {

    protected readonly PermissionKeys = PermissionKeys;
}
